import React, { useState } from 'react';
import { Container, Paper, Card, CardHeader, Avatar, CardContent, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import { useNavigate } from 'react-router-dom';

import mainStyles from 'styles/mainStyles';
import ConfirmDialog from 'components/ui/ConfirmDialog';

const OnboardContainer = ({ hasPadding, cancelRoute, title, subtitle, children, icon, noCancel, noAvatar }) => {
	const classes = mainStyles();
	const navigate = useNavigate();

	const [showCancelDialog, setShowCancelDialog] = useState(false);

	const handleCancel = () => {
		setShowCancelDialog(false);
	}

	const handleOk = () => {
		navigate(cancelRoute);
	}

	return (
		<Container component="main" maxWidth="lg" className={classes.container}>
			<Card elevation={0}>
				<CardHeader
					avatar={
						noAvatar === undefined ?
							<Avatar>{icon}</Avatar>
							: <></>
					}
					action={
						noCancel === undefined ?
							<IconButton onClick={() => setShowCancelDialog(true)}>
								<CancelIcon sx={{ fontSize: 34 }} />
							</IconButton>
							: <></>
					}
					title={title}
					subheader={subtitle}
				/>
				<CardContent>
					<Paper className={hasPadding ? classes.paper : classes.paperNoPadding} sx={{ width: '100%', overflow: 'hidden' }}>
						{children}
					</Paper>
				</CardContent>
			</Card>

			<ConfirmDialog visible={showCancelDialog} title='Dette vil afbryde' text='Er du sikker?' handleCancel={handleCancel} handleOk={handleOk} />
		</Container>
	)
}

export default OnboardContainer;